export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.accessToken = payload.access_token;
  newState.pageType = payload.page_type;

  return newState;
};
